// Shared wiring for the RFX HTMX modals that search server-side (#38845,
// #40524): select2 fetches a paginated, filtered page per keystroke rather than
// rendering a whole eligible set as <option>s, and the modal hides itself when
// the server triggers its close event.
export function initSelect2Modal({ modalId, selectId, placeholder }) {
  document.addEventListener('shown.bs.modal', (e) => {
    if (e.target.id !== modalId) return
    const $select = $(`#${selectId}`)
    if ($select.hasClass('select2-hidden-accessible')) return
    $select.select2({
      width: '100%',
      placeholder,
      dropdownParent: $(e.target),
      minimumInputLength: 1,
      ajax: {
        url: $select.data('searchUrl'),
        dataType: 'json',
        delay: 250,
        data: (params) => ({ q: params.term, page: params.page ?? 1 }),
        processResults: (data) => data,
      },
    })
  })
}

// The server dismisses a modal by triggering an event rather than by returning
// markup, so the open modal is found in the DOM rather than passed in.
export function hideModalOn(eventName, selector = '.modal.show') {
  document.addEventListener(eventName, () => {
    const openModal = document.querySelector(selector)
    if (!openModal) return
    const bsModal = bootstrap.Modal.getInstance(openModal)
    if (bsModal) bsModal.hide()
  })
}
